<template>
    <el-card class="instrument-card" @click="handleCardClick">
        <div class="instrument-image">
            <el-image :src="instrument.allImageUrls[0]" :alt="instrument.instrumentName" fit="cover">
                <template #error>
                    <div class="image-placeholder">无图片</div>
                </template>
            </el-image>
        </div>
        <div class="instrument-info">
            <h3 class="instrument-name" :title=" instrument.instrumentName ">{{ instrument.instrumentName }}</h3>
            <div class="instrument-meta">
                <p>平台: {{ instrument.platform }}</p>
                <p>仪器型号: {{ instrument.model }}</p>
            </div>
        </div>
    </el-card>
</template>

<script>
export default {
    name: 'InstrumentCard',
    // 定义接收的props
    props: {
        instrument: {
            type: Object,
            required: true,
            description: '仪器设备信息对象'
        }
    },
    methods: {
        handleCardClick() {
            //   如果使用命名路由，可以这样写：
            this.$router.push({
                name: 'InstrumentDetail',
                params: { id: this.instrument.instrumentNo }
            });
        }
    }
}
</script>

<style scoped>
.instrument-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    transition: transform 0.3s ease;
    margin-bottom: 40px !important;
}

.instrument-card:hover {
    transform: translateY(-5px);
}

.instrument-image {
    height: 160px;
    overflow: hidden;
}

.instrument-image img {
    width: 100%;
    height: 100%;
}

.image-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    color: #999;
}

.instrument-info {
    padding: 15px;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.instrument-name {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.instrument-meta {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
}
</style>